import $ from 'jquery';
import _ from 'underscore';
import autosize from 'lib/autosize';
import ajax from 'util/ajax';
import { $body, $window, jqGetElemByCmpName, jqGetElemById, jqCreateElem } from 'util/global';
import { EVT_MCQ_EDIT_FORM_SET_CONTEXT } from 'util/constants';
import * as latex from 'util/latex';
import { Anchors } from 'util/ui';
import { appendGetParams } from 'util/urls';
import contentModal from 'app/content_modal';
import { initGenericControllers } from 'app/generic_controllers';

const creationModal = {};

const vkey = window.vkey || {};

let $creationForm = null;

/**
 * Creation modals are attached to this object according to component key. For example,
 * the modal solvable creation component would be at
 * `cachedCreationModals.newsfeed_create_solvable`.
 * @type {Object}
 */
var cachedCreationModals = {};

/**
 * Key for the currently open creation modal
 * @type {String}
 */
var activeCreationModal;

/**
 * Set to true when adding something. Used in vkey to trigger the feed item modal.
 * @type {String}
 */
creationModal.justAddedViaModal = '';

/** @type {String} */
var mcqDummyText = null;

/** @type {String} */
var mcqCorrectText = null;

/** @type {String} */
var currentAnswerType = 'mcq';

/**
 * Changes the url of the creation modal deferred component according to the data attributes
 * of the trigger button
 * @param {JQuery} $component
 * @param {Object} data - data from the modal trigger button
 */
var updateCreationComponent = function ($component, data) {
  let $deferredComponent = $component.find('.cmp-deferred');
  // serialize the data to test if the component needs to be reloaded
  var thisUpdate =
    (data.post_to_set_name || '<none>') +
    '|' +
    (data.clone_from_problem || '<none>') +
    '|' +
    (data.pre_filled_skill || '<none>') +
    '|' +
    (data.pre_filled_topic || '<none>') +
    '|' +
    (data.wiki || '<none>');

  // Move the deferred component out of its parent componet. This will prevent it from
  // being overwritten when it is loaded, allowing it to be reloaded as necessary
  if ($deferredComponent.length) {
    $deferredComponent.appendTo($body);
    $component.data('orig-deferred', $deferredComponent);
  } else {
    $deferredComponent = $component.data('orig-deferred');
  }

  // Only reload if the data has changed. This can happen if there are multiple trigger buttons
  // on a page each with different data.
  if ($component.data('last-update') !== thisUpdate) {
    // use a clone of the original component
    $deferredComponent = $deferredComponent.clone();

    // add the deferred component to the parent component
    $component.empty().append($deferredComponent);

    // add group, set, and/or problem data
    var btnParams = _.pick(
      data,
      'group',
      'post_to_set_name',
      'clone_from_problem',
      'pre_filled_skill',
      'pre_filled_topic',
      'wiki',
    );
    if (_.keys(btnParams).length) {
      var url = $deferredComponent.data('cmp_url');
      var finalUrlParams = _.extend({}, btnParams, {
        is_modal: true,
      });
      const finalUrl = appendGetParams(url, finalUrlParams);
      $deferredComponent.data('cmp_url', finalUrl);
    }

    // store the update string for the next time we try to update the component
    $component.data('last-update', thisUpdate);
  }
};

/**
 * Controller for showing the create note/problem modals
 * @param {JQuery} $trigger
 */
creationModal.clickHandler = function ($trigger) {
  var data = $trigger.data();
  var $cmp = null;

  $trigger.on('click', e => {
    // don't prevent opening a new tab if the user wants to do it that way
    if (!e.metaKey) {
      $cmp = cachedCreationModals[data.target] || jqGetElemByCmpName(data.target);
      cachedCreationModals[data.target] = $cmp;

      // initialize one-time things
      if (!$cmp.data('modal-loaded')) {
        // if there's no deferred component, we're looking at the full-page creation form
        if (!$cmp.find('.cmp-deferred').length) {
          return true;
        }
        $cmp.data('modal-loaded', true);
      }

      e.preventDefault();

      // check if component should be updated based on $trigger's data attributes
      updateCreationComponent($cmp, data);

      // show the modal
      if ($cmp.data('modal')) {
        $cmp.modal();
      } else {
        $cmp.on('shown', () => {
          activeCreationModal = data.target;
        });
        $cmp.modal('show');
      }
    }
    return true;
  });
};

var $saved_image_field = null;
var allowed_image_types = ['gif', 'jpg', 'jpeg', 'png'];
var post_image_button_events = function () {
  var $image_btn = $('#attach-image'), // link that triggers image field input
    $image_field = $('#id_image'); // image field

  if (!$image_btn.length) {
    return;
  }

  var $attached_image = $('#preview-img'), // attached image container (for previewing)
    $attached_image_name = $('#preview-img-name'), // attached image name container
    image_tmpl = _.template($image_btn.data('tmpl')),
    error_tmpl = _.template($image_btn.data('error'));

  // save the original button text
  $image_btn.data('orig-content', $image_btn.html());

  var update_image_button = function () {
    var split_file_path = $image_field.val().split(/\/|\\/g),
      file_name = split_file_path.length > 0 ? split_file_path.pop() : false,
      extension = file_name ? file_name.split('.').pop() : '';

    if (file_name && file_name.length > 0) {
      $saved_image_field = $image_field;

      var image_text;
      if (_.contains(allowed_image_types, extension.toLowerCase())) {
        $image_btn.next('.errorlist').remove();
        image_text = image_tmpl({
          image: file_name,
        });
      } else {
        image_text = $image_btn.data('orig-content');
        $image_btn.next('.errorlist').remove();
        $image_btn.after(
          error_tmpl({
            extension: extension,
          }),
        );
        $image_field.val('');
        $saved_image_field = null;
      }

      $image_btn.html(image_text);

      if ($attached_image.length > 0) {
        $attached_image.show();
        $attached_image_name.text(file_name);
      }
    } else {
      $image_btn.html($image_btn.data('orig-content'));
    }
  };

  // check if there is a stored image value
  if ($saved_image_field !== null) {
    $image_field.after($saved_image_field);
    $image_field.remove();
    $image_field = $('#id_image');
    update_image_button();
  }

  // map this button to the image field
  $image_btn.on('click', function (e) {
    e.preventDefault();
    $image_field.click();
  });

  // when updating the image field, replace the button
  // text with the file name
  $image_field.on('change', update_image_button);
};

/**
 * Handle the redirect after adding something from a modal
 * @param {String} destination_url - url we're trying to redirect
 * @param {Object} data - component request data
 */
creationModal.redirectHandler = function (destination_url, data) {
  window.location = destination_url;
};

function handleMCQPlaceholders($fieldContainer) {
  setTimeout(function () {
    if (currentAnswerType === 'mcq') {
      $fieldContainer.find('label.multi-select-extra span').html('Correct answer');
      if ($fieldContainer.find('input:checked').length === 0) {
        $fieldContainer.find('input[type=checkbox]:first').prop('checked', true);
      }
    } else {
      $fieldContainer.find('label.multi-select-extra span').html('Required answer');
    }
    $fieldContainer
      .find('input[type=text]')
      .removeClass('correct')
      .attr('placeholder', mcqDummyText);
    $fieldContainer.find('input:checked').each(function () {
      $(this)
        .parents('.mcq-field')
        .find('input[type=text]')
        .addClass('correct')
        .attr('placeholder', mcqCorrectText);
    });
  });
}

creationModal.form = $form => {
  const $textareas = $form.find('textarea');
  const $answerTypeSelectors = $form.find('.type-select');
  const $numericalAnswerField = $form.find('.numerical-answer-field');
  const $numericalAnswerInput = $numericalAnswerField.find('input');
  const $optionalFields = $form.find('.field-level');
  const $fieldContainer = $form.find('.fields');
  const solvableId = $form.data('solvable-id') || 0; // default for the creation form

  $creationForm = $form;

  const submitForm = isPreview => {
    let fileValues = '';
    $form.find('[type=file]').each((i, fileInput) => {
      fileValues += $(fileInput).val();
    });
    if (fileValues.length) {
      $form.submit();
    } else {
      if (isPreview) {
        $window.trigger($.Event('creationmodal.preview'));
      }
      ajax('').form($form[0]);
    }
  };

  autosize($textareas);

  $form.find('.btn-preview-post').on('click', e => {
    e.preventDefault();
    $form.addClass('loading');

    submitForm(true);
  });

  $form.find('.btn-edit').on('click', e => {
    e.preventDefault();
    $form.removeClass('previewing');
    $('.publish-list, .publish-wiki-container').removeClass('hide');
    $form.find('textarea').trigger('autosize.resize');
    _.defer(() => {
      Anchors.scrollToTarget($('.publish-wiki-form'));
    });
  });

  // "Post" button -- submits the form
  $form.find('.btn-confirm').on('click', e => {
    e.preventDefault();
    $form.find('.preview-post-field, .preview-solvable-field, .preview-wiki-field').val('');

    $form.addClass('loading');
    $(e.currentTarget).addClass('dim');

    submitForm(false);
  });

  const handleNumericalInput = () => {
    if (!$numericalAnswerInput.closest('.nf-answer-field').hasClass('number')) {
      return;
    }
    const value = $numericalAnswerInput.val();

    // hide/show float input helpers
    const invalidRegex = /[^-\d.eE+]/;
    const floatRegex = /[.eE]/;
    const invalidClass = 'invalid';
    const usageClass = 'usage';
    if (invalidRegex.test(value)) {
      $numericalAnswerField.removeClass(usageClass).addClass(invalidClass);
    } else if (floatRegex.test(value)) {
      $numericalAnswerField.removeClass(invalidClass).addClass(usageClass);
    } else {
      $numericalAnswerField.removeClass(`${invalidClass} ${usageClass}`);
    }

    // check for blank field
    $optionalFields.toggleClass('disabled', value.length === 0);
  };

  $numericalAnswerInput.on('keyup change', handleNumericalInput);
  if ($numericalAnswerInput.length) {
    $optionalFields.toggleClass('disabled', $numericalAnswerInput.val().length === 0);
  }

  // solvable answer type selector
  const handleSelection = $selection => {
    let mcqAnswer;
    currentAnswerType = $selection.val();
    $answerTypeSelectors.find('.active').removeClass('active');
    $selection.parents('label').addClass('active');
    $selection
      .closest('.nf-answer-field')
      .removeClass('number mcq multi_select')
      .addClass(currentAnswerType);
    switch (currentAnswerType) {
      case 'mcq':
      case 'multi_select':
        handleMCQPlaceholders($fieldContainer);
        creationModal.variableNumChoices.checkForBlankFields(solvableId);
        break;
      case 'number':
        // copy mcq correct answer to number answer
        mcqAnswer = parseFloat(jqGetElemById('id_mcq_answer_1').val());
        if (!Number.isNaN(mcqAnswer)) {
          jqGetElemById('id_number_answer').val(mcqAnswer);
        }
        handleNumericalInput();
        break;
      default:
      // do nothing
    }
  };
  $answerTypeSelectors.find('input').on('change', e => {
    handleSelection($(e.currentTarget));
  });

  // deal with initial selection
  const $selectedSelector = $answerTypeSelectors.find('input:checked');
  if ($selectedSelector.length === 0) {
    $answerTypeSelectors.find('input').first().prop('checked', 'checked');
  } else {
    handleSelection($selectedSelector);
  }
};

/**
 * Create problem with 2-8 mcq choices controller
 */
creationModal.variableNumChoices = (() => {
  const self = {};
  /**
   * @type {Object}
   * @property {JQuery} $optionalFields
   * @property {Array} choiceData
   */
  const contexts = {};

  /**
   * Disables topic/level fields if the MCQ fields are blank
   * @public
   * @method
   */
  self.checkForBlankFields = solvableId => {
    if (!contexts.hasOwnProperty(solvableId)) {
      $window.on(`${EVT_MCQ_EDIT_FORM_SET_CONTEXT}_${solvableId}`, () => {
        // try later when the context is set for this solvable in another controller
        self.checkForBlankFields(solvableId);
      });
      return;
    }

    const { choiceData, $optionalFields } = contexts[solvableId];

    if (choiceData && choiceData.length && $optionalFields && $optionalFields.length) {
      const $fieldset = $optionalFields.first().closest('.nf-answer-field');
      if ($fieldset.hasClass('mcq') || $fieldset.hasClass('multi_select')) {
        const nonblankFields = choiceData.filter(choice => choice !== null && choice.length > 0);
        $optionalFields.toggleClass('disabled', nonblankFields.length === 0);
      }
    }
  };

  /**
   * Controller
   * @param {JQuery} $container - the main create problem container
   */
  self.controller = $container => {
    const $addOptionField = $container.find('.add-choice');
    const $fieldsContainer = $container.find('.fields');
    const fieldTemplate = _.template($container.find('.field-template').text());
    const $numAnswersField = $container.parents('form').find('#id_num_mcq_answers');
    const choiceData = []; // array of current choice values
    const checkboxData = []; // array of current checkbox values
    const messageData = []; // array of current message values
    const containerData = $container.data();
    const solvableId = containerData.solvableId || 0; // default for the creation form
    const context = {};
    let numAnswers = +$numAnswersField.val() || 4; // the number of visible answer fields
    let renderedOnce = false; // flag for the initial rendering

    mcqDummyText = containerData.dummyText;
    mcqCorrectText = containerData.correctText;

    contexts[solvableId] = context;
    $window.trigger($.Event(`${EVT_MCQ_EDIT_FORM_SET_CONTEXT}_${solvableId}`));

    context.choiceData = choiceData;
    context.$optionalFields = $container.parents('form').find('.field-level');
    $fieldsContainer.find('input[type=text]').each((index, el) => {
      choiceData.push(el.value);
    });

    $fieldsContainer.find('input[type=checkbox]').each((index, el) => {
      checkboxData.push(el.checked);
    });
    // make sure we don't get any of the cloned textareas
    for (let i = 1; i <= 8; i++) {
      const $textarea = $fieldsContainer.find(`#edit-mcq-message-${i}`);
      if ($textarea && $textarea.val()) {
        messageData[i - 1] = $textarea.val();
      }
    }

    // the rendering function
    const render = () => {
      let renderedChoices = '';
      choiceData.forEach((choiceParam, index) => {
        const choice = choiceParam === 'null' ? null : choiceParam;

        let message = '';
        if (messageData && messageData[index] && messageData[index] !== 'null') {
          message = messageData[index];
        }

        // set choice to '' if the field is null but should be visible
        // set choice to null if the field is '' but should be hidden
        if (choice === null && index < numAnswers) {
          choiceData[index] = '';
        } else if (choice !== null && choice.length === 0 && index >= numAnswers) {
          choiceData[index] = null;
        }

        const $error = $fieldsContainer.children(`#mcq-choice-${index + 1}`).find('.errorlist');
        const isHidden = choiceData[index] === null;

        renderedChoices += fieldTemplate({
          fieldNumber: index + 1,
          value: choice,
          message,
          tabindex: index + 2,
          hidden: isHidden,
          error: $error.length && !isHidden ? $error[0].outerHTML : '',
          passive: renderedOnce,
          deletable: numAnswers > 2,
          multiSelectSelected: checkboxData[index],
          user: containerData.user,
        });
      });

      // add the new html
      $fieldsContainer.html(renderedChoices);

      // show/hide the add field button
      $addOptionField.toggleClass('hide', numAnswers === 8);

      // initialize autosave
      const genericControllerCallback = () => {
        // on subsequent renders, just save the current values
        if (renderedOnce) {
          $fieldsContainer.find('input').each((index, el) => {
            $(el).trigger('autosave.save');
          });
          // on the initial rendering, deal with autosave issues...
        } else {
          // map field values (from autosave) to choiceData
          $fieldsContainer.find('input[type=text]').each((index, el) => {
            const { value } = el;
            choiceData[index] = value.length === 0 && index > 3 ? null : value;
          });

          // check if there are hidden fields with values (i.e. there's a value
          // in choiceData with an index higher than numAnswers)
          let maxEntered = null;
          let i = choiceData.length - 1;

          // start at the end and work backwards to find the highest index
          // with a value
          for (i; i >= 0; i--) {
            if (choiceData[i] !== null && choiceData[i].length) {
              maxEntered = i;
              break; // stop when you find something
            }
          }

          // mark that it has been rendered
          renderedOnce = true;

          // if there's a value, you adjust numAnswers and re-render
          // (inefficient, but probably not much different than figuring out which
          // specific fields need to be visible and changing them individually)
          if (maxEntered !== null && maxEntered !== numAnswers - 1) {
            if (maxEntered === 0) {
              numAnswers = 2;
            } else {
              numAnswers = maxEntered + 1;
            }
            $numAnswersField.val(numAnswers);
            render();
          }

          self.checkForBlankFields(solvableId);
        }
      };

      initGenericControllers($fieldsContainer, {
        callback: genericControllerCallback,
      });

      // delete button handler
      $fieldsContainer.find('.delete').on('click', e => {
        e.preventDefault();

        const $this = $(e.currentTarget);

        // ignore disabled buttons
        if ($this.hasClass('disabled')) {
          return;
        }

        const $field = $this.parents('.mcq-field');
        const index = $field.index();

        // remove the value from choiceData, push a null to the end to maintain 8 items
        choiceData.splice(index, 1);
        choiceData.push(null);

        // remove the value from checkboxData, push a false to the end
        checkboxData.splice(index, 1);
        checkboxData.push(false);

        // adjust numAnswers
        numAnswers--;
        $numAnswersField.val(numAnswers);

        // re-render
        render();
      });

      // sync choiceData with autosave
      $fieldsContainer.find('input[type=text]').on('keyup change input', e => {
        const $this = $(e.currentTarget);
        choiceData[$this.parents('.mcq-field').index()] = $this.val();
        self.checkForBlankFields(solvableId);
      });

      $fieldsContainer.find('input[type=checkbox]').on('change', e => {
        const checkbox = e.currentTarget;
        const $field = $(checkbox).parents('.mcq-field');
        if (currentAnswerType === 'mcq' && checkbox.checked) {
          const $otherFields = $fieldsContainer.find('input[type=checkbox]').not(checkbox);
          $otherFields.prop('checked', false);
          $otherFields
            .parents('.mcq-field')
            .find('input[type=text]')
            .removeClass('correct')
            .attr('placeholder', mcqDummyText);
        }
        checkboxData[$field.index()] = checkbox.checked;
        $field
          .find('input[type=text]')
          .toggleClass('correct', checkbox.checked)
          .attr('placeholder', checkbox.checked ? mcqCorrectText : mcqDummyText);
      });

      handleMCQPlaceholders($fieldsContainer);
    };

    // add field button handler
    $addOptionField.on('click', e => {
      e.preventDefault();

      // adjust numAnswers
      numAnswers++;
      $numAnswersField.val(numAnswers);

      // re-render
      render();
    });

    render();
    self.checkForBlankFields(solvableId);
  };

  return self;
})();

creationModal.guidelines = function ($container) {
  $container.find('.btn-guidelines').on('click', function (e) {
    e.preventDefault();
    $creationForm.toggleClass('guidelines');
    _.defer(function () {
      $creationForm.toggleClass('in');
    });
  });
};

creationModal.notesExamples = function ($container) {
  contentModal.feeditem_modal($container.parent());
  $container.find('.modal-target').each(contentModal.modal_events);
};

creationModal.progressiveFields = function ($container) {
  var fields = $container
    .data('fields')
    .split(',')
    .map(function (fieldQuery) {
      return $container.find(fieldQuery);
    })
    .filter(function ($field) {
      return $field.length > 0;
    });

  var updateFields = function () {
    var i = 0;
    var shouldDisable = false;
    // if a field is blank, disable all of the following fields
    for (i; i < fields.length; i++) {
      fields[i].parents('.field').toggleClass('disabled', shouldDisable);
      shouldDisable = shouldDisable || fields[i].val().trim() === '';
    }
  };

  _.defer(function () {
    fields.forEach(function ($field, index) {
      $field.on('change', updateFields);
      // prevent tabbing to disabled fields
      $field.siblings('input').on('focus', function () {
        if ($field.parents('.field').hasClass('disabled')) {
          $(this).blur();
        }
      });
    });
  });

  updateFields();
};

/**
 * Filter wikis that need help by need writers, need examples, need feedback
 * @param {JQuery} $container
 */
creationModal.filterWikis = function ($container) {
  var $filterBtns = $container.find('.btn-filter'),
    $seeMoreBtns = $container.find('.see-more-btn');

  // handle filter button clicks
  $filterBtns.on('click', function (e) {
    e.preventDefault();

    var $this = $(this),
      value = $this.data('value'),
      allValues = 'needs-writers needs-feedback needs-examples';

    $container.removeClass(allValues).addClass(value);
    $filterBtns.removeClass('active');
    $this.addClass('active');
  });

  // handle see more button clicks
  $seeMoreBtns.on('click', function () {
    $(this).parents('.publish-wiki-list').addClass('expanded');
  });
};

module.exports = creationModal;
